import Dexie, { type EntityTable } from "dexie";
import { Message } from "../type";

const db = new Dexie("AiChatDatabase") as Dexie & {
  messageList: EntityTable<Message, "id">;
};
db.version(1).stores({
  messageList:
    "id, role, reasonContent, thoughtContent, date, audio, imageList, goodsList, type, requestId, sessionId, stageId, like, dislike",
});

export default db;
